import React, { useEffect, useState } from 'react';
import { Alert, Spinner, Badge } from '../../../core/ui';
import { Navigate } from 'react-router-dom';
import { useTranslation } from '../../../core/context/TranslationContext';
import { getFamilyStatements } from '../api/family';
import { useFamily } from '../context/FamilyContext';
import { memberColor, ownerInitial } from '../format';
import ScopeSwitcher from './ScopeSwitcher';
import styles from './FamilyStatements.module.css';

export default function FamilyStatements() {
  const { t } = useTranslation();
  const { family, loading: familyLoading } = useFamily();
  const [statements, setStatements] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!family) return;
    (async () => {
      try {
        setLoading(true);
        const data = await getFamilyStatements();
        setStatements(Array.isArray(data) ? data : []);
      } catch (err) {
        setError(err.response?.data?.message || t('error'));
      } finally {
        setLoading(false);
      }
    })();
  }, [family, t]);

  if (familyLoading) return <Spinner className={styles.m4} />;
  if (!family) return <Navigate to="/family/create" replace />;

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <h4 className={styles.heading}>{t('family.statements')}</h4>
        <ScopeSwitcher
          current="family"
          mineRoute="/budget/statements"
          familyRoute="/family/statements"
        />
      </div>
      {error && <Alert variant="danger">{error}</Alert>}
      {loading ? <Spinner /> : (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>{t('budget.period')}</th>
              <th>{t('budget.totalDue')}</th>
              <th>{t('budget.dueDate')}</th>
              <th>{t('username')}</th>
            </tr>
          </thead>
          <tbody>
            {statements.map(s => (
              <tr key={s.id}>
                <td>{s.periodStart} → {s.periodEnd}</td>
                <td>{s.totalDueTry != null ? `₺${Number(s.totalDueTry).toFixed(2)}` : '-'}</td>
                <td>{s.dueDate || '-'}</td>
                <td>
                  <Badge
                    style={{ background: memberColor(s.owner?.username || '') }}
                    className={styles.me1}
                  >
                    {ownerInitial(s.owner?.username)}
                  </Badge>
                  {s.owner?.username}
                </td>
              </tr>
            ))}
            {statements.length === 0 && (
              <tr><td colSpan={4} className={styles.centerMuted}>{t('noData')}</td></tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}
